import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  municipalities: [],
  municipality: null,
  filteredData: []
}

// mutations
export const mutations = {
  [types.SET_MUNICIPALITIES] (state, municipalities) {
    state.municipalities = municipalities
  },
  [types.SET_MUNICIPALITY] (state, municipality) {
    state.municipality = municipality
  },
  [types.FETCH_MUNICIPALITY_FAILURE] (state) {
    state.municipality = null
  },
  filterMunicipalities (state, data) {
    state.filteredData = data
  }
}

// actions
export const actions = {
  async fetchMunicipalities ({ commit }) {
    try {
      const { data } = await axios.get('/municipalities?include=department')
      commit(types.SET_MUNICIPALITIES, data)
    } catch (e) {
      console.log(e)
    }
  },
  async fetchMunicipality ({ commit }, municipality) {
    try {
      const { data } = await axios.get(`/municipalities/${municipality.id}`)

      commit(types.SET_MUNICIPALITY, { municipality: data })
    } catch (e) {
      commit(types.FETCH_MUNICIPALITY_FAILURE)
    }
  },

  async createMunicipality (context, municipality) {
    try {
      await axios.post('/api/municipalities', municipality)
      context.dispatch('fetchMunicipalities')
    } catch (e) {
      console.log(e)
    }
  },

  async updateMunicipality (context, municipality) {
    try {
      await axios.put(`/api/municipalities/${municipality.id}`, municipality)
      context.dispatch('fetchMunicipalities')
    } catch (e) { }
  },

  async deleteMunicipality (context, municipality) {
    try {
      await axios.delete(`/api/municipalities/${municipality.id}`)
      context.dispatch('fetchMunicipalities')
    } catch (e) { }
  }
}

// getters
export const getters = {
  municipalities: state => state.municipalities,
  getMunicipalityByDepartmentId: (state) => (id) => {
    return state.municipalities.filter(municipality => municipality.department_id === id)
  },
  filteredData: state => state.filteredData
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/municipality.js